@if (message) {
  <div
    class="group flex items-center gap-2"
    [ngClass]="{
      'flex-row': !message.sender.isSelf,
      'flex-row-reverse': message.sender.isSelf
    }"
  >
    @if (message.sender) {
      <lib-avatars [persons]="message.sender.firstName && message.sender.lastName ? [message.sender] : []" [size]="32"></lib-avatars>
    }

    <div class="flex flex-col items-end">
      @if (message.text) {
        <div
          class="flex flex-col gap-2 rounded-2xl px-3 py-2"
          [ngClass]="{
            'bg-background-light-blue': !message.sender.isSelf,
            'bg-background-light-mid-blue': message.sender.isSelf
          }"
        >
          @if (!message.sender.isSelf && participantCount() > 2) {
            <div class="typo-h7-semibold">{{ message.sender.firstName }} {{ message.sender.lastName }}</div>
          }
          <div
            class="typo-h5-light whitespace-pre-wrap font-light text-text-black"
            libHighlight
            [searchTerm]="searchTextToHighlight"
            [text]="message.text"
            classesToApply="bg-states-orange text-text-white"
          ></div>
        </div>
      }
      @if (
        message.attachments &&
        (message.attachments.allAttachments.length || message.attachments.uncategorized.length || message.attachments.fullSeries)
      ) {
        <div
          class="group inline-flex flex-row-reverse items-center gap-2"
          [class.flex-row-reverse]="!message.sender.isSelf"
          [class.justify-end]="!message.sender.isSelf"
        >
          <div class="flex flex-wrap gap-2" [class.justify-end]="message.sender.isSelf">
            @if (message.attachments.fullSeries; as fullSeries) {
              <div class="relative">
                <lib-attachment
                  class="col-start-1 row-start-1"
                  (click)="onPreviewFullSeriesClick($event, fullSeries)"
                  [ffdPushTagOnClick]="{
                    event: TagEvent.CollaborationImagePreviewed,
                    type: 'multiple'
                  }"
                  [selected]="!!isFullSeriesFullySelected() || !!isFullSeriesPartiallySelected()"
                  [groupSelection]="true"
                  [groupSelectionSize]="destructuredFullSeries()?.length ?? 0"
                  [selectedImageIds]="selectedFullSeriesItems()"
                  [size]="isSupportCollab() ? 'support-collab' : 'normal'"
                >
                  <lib-full-series-preview class="flex h-full items-center" [fullSeries]="fullSeries" />
                  <div details class="typo-h8-light flex flex-shrink-0 justify-between px-2 py-[5px] text-text-primary">
                    <span class="typo-h8-light">{{ 'collab_attachment_full_series' | translate }}</span>
                  </div>
                </lib-attachment>
                @if (selectingAttachments() && !saveToPmsProgress()) {
                  <div
                    class="absolute top-0 z-10 flex w-full cursor-pointer justify-between"
                    (click)="onPreviewFullSeriesClick($event, fullSeries)"
                  >
                    <lib-checkbox
                      #checkbox
                      class="group col-start-1 row-start-1 ms-3 mt-3 grid !h-4 !w-4 self-start justify-self-start rounded border-[1px] border-text-white bg-text-white/30"
                      (click)="toggleFullSeriesSelection($event, !isFullSeriesFullySelected() && !isFullSeriesPartiallySelected())"
                      [checked]="!!isFullSeriesFullySelected() || !!isFullSeriesPartiallySelected()"
                      [size]="'small'"
                      [indeterminate]="!!isFullSeriesPartiallySelected() && !isFullSeriesFullySelected()"
                    />
                    <div
                      class="typo-h8-semibold absolute right-0 top-0 z-[51] m-3 flex h-[1rem] items-center justify-center overflow-hidden rounded-full bg-text-black/60 p-1.5 leading-4 text-text-white"
                      [ngClass]="{
                        'aspect-square': !selectingAttachments()
                      }"
                    >
                      {{ selectedFullSeriesCount() }} / {{ destructuredFullSeries()?.length }} <span class="ms-1 font-light">selected</span>
                    </div>
                  </div>
                }

                @if (selectingAttachments() && selectedFullSeriesCount() > 0) {
                  <div class="absolute top-0 z-10 flex w-full cursor-pointer justify-between">
                    @if (saveToPmsProgress() && !saveToPmsSuccess()) {
                      <ng-lottie [options]="lottieOptions" currentColor class="ms-3 mt-3 h-4 w-4 text-primary-blue" />
                    }
                    @if (saveToPmsSuccess()) {
                      <div
                        class="group col-start-1 row-start-1 ms-3 mt-3 grid aspect-square h-4 w-4 items-center justify-center self-start justify-self-start rounded-full bg-text-secondary/60"
                      >
                        <svg-icon key="px-24-tick" class="text-text-white" size="xs"></svg-icon>
                      </div>
                    }
                    @if (saveToPmsProgress()) {
                      <div
                        class="typo-h8-semibold absolute right-0 top-0 z-[51] m-3 flex h-[1rem] items-center justify-center overflow-hidden rounded-full bg-text-black/60 p-1.5 leading-4 text-text-white"
                      >
                        {{ selectedFullSeriesCount() }} / {{ destructuredFullSeries()?.length }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @for (attachment of message.attachments.uncategorized; track attachment.id) {
              <div class="grid">
                <lib-attachment
                  [attachment]="attachment"
                  class="col-start-1 row-start-1"
                  [selectedImageIds]="selectedAttachmentIds()"
                  [selected]="selectedAttachmentIds().includes(attachment.id)"
                  [size]="isSupportCollab() ? 'support-collab' : 'normal'"
                >
                  @if (attachment.name || attachment.date) {
                    <div details class="typo-h8-light flex flex-shrink-0 justify-between px-2 py-[5px] text-text-primary">
                      @if (attachment.date; as date) {
                        <span class="typo-h8-semibold">{{ date | date: 'MM/dd/YY' }}</span>
                      }
                      <span class="typo-h8-light">{{ attachment.name }}</span>
                    </div>
                  }
                </lib-attachment>

                @if (selectingAttachments() && !saveToPmsProgress()) {
                  <div
                    class="z-20 col-start-1 row-start-1 grid cursor-pointer grid-cols-subgrid"
                    (click)="toggleAttachmentSelection(attachment.id)"
                  >
                    <lib-checkbox
                      class="group col-start-1 row-start-1 ms-3 mt-3 grid !h-4 !w-4 self-start justify-self-start rounded border-[1px] border-text-white bg-text-white/30"
                      [checked]="selectedAttachmentIds().includes(attachment.id)"
                    />
                  </div>
                }

                @if (selectingAttachments() && selectedAttachmentIds().includes(attachment.id)) {
                  <div class="z-10 col-start-1 row-start-1 grid cursor-pointer grid-cols-subgrid">
                    @if (saveToPmsProgress() && !saveToPmsSuccess()) {
                      <ng-lottie [options]="lottieOptions" currentColor class="ms-3 mt-3 h-4 w-4 text-primary-blue" />
                    }
                    @if (saveToPmsSuccess()) {
                      <div class="ms-3 mt-3 flex aspect-square h-4 w-4 items-center justify-center rounded-full bg-text-secondary/60">
                        <svg-icon key="px-24-tick" class="text-text-white" size="xs"></svg-icon>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
        @if (
          (message.attachments.allAttachments.length > 1 || selectingAttachments()) &&
          !(message.isSending || message.isFailed) &&
          !saveToPmsProgress()
        ) {
          <div [class.self-end]="message.sender.isSelf" class="flex items-center gap-4">
            @if (selectingAttachments()) {
              <span class="text-h5 font-normal text-text-light">{{
                'collab_message_attachments_selected' | translate: { input1: selectedAttachments().length }
              }}</span>
              <button class="btn-text inline text-h5" (click)="onDeselectAttachmentsClick()">
                {{ 'collab_message_select_images_cancel' | translate }}
              </button>
              @if (saveToDesktopMode()) {
                <button
                  class="btn-secondary inline text-h5"
                  (click)="onDownloadAttachmentsClick()"
                  [disabled]="!selectedAttachments().length"
                >
                  {{ 'collab_message_save_to_device' | translate }}
                </button>
              }

              @if (showcaseMode && saveToPmsMode()) {
                <button class="btn-primary inline text-h5" (click)="onSaveToPmsClick()" [disabled]="!selectedAttachments().length">
                  {{ 'collab_message_context_save_to_pms' | translate }}
                </button>
              }
            }
          </div>
        }
        @if (saveToPmsProgress() && selectingAttachments()) {
          <div class="my-2 flex w-full max-w-2xl flex-col gap-1">
            @if (!saveToPmsSuccess()) {
              <div class="flex w-full items-center gap-2">
                <div class="h-0.5 w-full overflow-hidden rounded-sm bg-background-disabled">
                  <div class="h-full bg-primary-blue transition-all" [style.width.%]="saveToPmsProgress()"></div>
                </div>
                <button (click)="cancelSaveToPms()"><svg-icon [key]="'px-16-x'" size="sm"></svg-icon></button>
              </div>
              <p class="text-h5 text-text-light">
                {{
                  (selectedAttachments().length > 1 ? 'collab_message_pms_saving_plural' : 'collab_message_pms_saving')
                    | translate: { input1: selectedAttachments().length }
                }}
              </p>
            } @else {
              <div class="flex justify-end gap-1">
                <svg-icon key="px-24-tick" size="sm" class="text-secondary-green"></svg-icon>
                <p class="text-h5 text-text-light">
                  {{
                    (selectedAttachments().length > 1 ? 'collab_message_pms_saved_plural' : 'collab_message_pms_saved')
                      | translate: { input1: selectedAttachments().length }
                  }}
                </p>
              </div>
            }
          </div>
        }
      }
    </div>
    @if (message.isSending) {
      <div class="flex items-center justify-end gap-x-1">
        <ng-lottie [options]="lottieOptions" currentColor class="h-4 w-4 text-primary-blue"></ng-lottie>
        <div class="typo-h5-book text-text-light">
          {{ 'collab_message_sending' | translate }}
        </div>
      </div>
    }
    @if (message.isFailed) {
      <div class="flex items-center justify-end gap-x-1">
        <svg-icon class="text-states-red" key="px-24-warning" size="sm"></svg-icon>
        <div class="typo-h5-book text-text-light">
          {{ 'collab_message_sending_error' | translate }}
        </div>
        <button class="btn-text" [style.lineHeight]="'16px'" [style.fontSize]="'14px'" (click)="onRetryClick()">
          {{ 'collab_message_retry_button_label' | translate }}
        </button>
      </div>
    }
    @if (!isCollabSoftDeleted()) {
      <button class="invisible flex h-4 w-4 items-center justify-center group-hover:visible" [matMenuTriggerFor]="contextMenu">
        <svg-icon class="text-text-light" size="sm" key="px-16-more"></svg-icon>
      </button>
    }
  </div>
}

<mat-menu #contextMenu="matMenu">
  <div class="flex w-[155px] flex-col gap-1">
    <!-- The edit button will be implemented later -->
    <!-- @if (message?.sender?.isSelf) {
      <button class="typo-h5-medium flex justify-between px-2 text-text-primary" (click)="onEditMessageClick()">
        <span class="py-1">{{ 'collab_message_menu_edit' | translate }}</span>
        <svg-icon class="shrink-0" size="md" key="px-24-message-edit"></svg-icon>
      </button>
      <hr class="border-text-white" />
    } -->
    @if (message?.sender?.isSelf) {
      <button class="typo-h5-medium flex justify-between px-2 text-text-primary" (click)="onDeleteMessageClick()">
        <span class="py-1">{{ 'collab_message_menu_delete' | translate }}</span>
        <svg-icon class="shrink-0" size="md" key="px-24-message-delete"></svg-icon>
      </button>
    }
    <!-- <hr class="border-text-white" /> -->
    <!-- The reply button will be implemented later -->
    <!-- <button class="typo-h5-medium flex justify-between px-2 text-text-primary" (click)="onReplyMessageClick()">
      <span class="py-1">{{ 'collab_message_menu_reply' | translate }}</span>
      <svg-icon class="shrink-0" size="md" key="px-24-message-reply"></svg-icon>
    </button> -->
    <hr class="border-text-white" />
    <button class="typo-h5-medium flex justify-between px-2 text-text-primary" (click)="onMarkMessageUnreadClick()">
      <span class="py-1">{{ 'collab_message_menu_mark_unread' | translate }}</span>
      <svg-icon class="shrink-0" size="md" key="px-24-message-mark-unread"></svg-icon>
    </button>
    @if (
      message?.attachments &&
      (message?.attachments?.allAttachments?.length || message?.attachments?.uncategorized?.length || message?.attachments?.fullSeries)
    ) {
      @if (showcaseMode) {
        <hr class="border-text-white" />
        <button class="typo-h5-medium flex justify-between px-2 text-text-primary" (click)="onSaveToPmsModeClick()">
          <span class="py-1">{{ 'collab_message_context_save_to_pms' | translate }}</span>
          <svg-icon class="shrink-0" size="md" key="px-24-chart"></svg-icon>
        </button>
      }
      <hr class="border-text-white" />
      <button class="typo-h5-medium flex justify-between px-2 text-text-primary" (click)="onSaveToDesktopModeClick()">
        <span class="py-1">{{ 'collab_message_menu_download' | translate }}</span>
        <svg-icon class="shrink-0" size="md" key="px-24-download"></svg-icon>
      </button>
    }
  </div>
</mat-menu>
